import _ from 'lodash';

function emptyStringToNull(obj) {
  return _.mapValues(obj, (value) => (value === '' ? null : value));
}

export default emptyStringToNull;
